<app-header></app-header>
<div class="container-xxl container-fluid custom-margin">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>